import TabFilter from "../shared/TabFilter";

const TABS = ["active", "upcoming", "expired", "all"];

type WhatsNewTabsProps = {
  selectedTab: string;
  onSelect: (tab: string) => void;
};

const WhatsNewTabs: React.FC<WhatsNewTabsProps> = ({
  selectedTab,
  onSelect,
}) => {
  return (
    <TabFilter tabs={TABS} selectedTab={selectedTab} onSelect={onSelect} />
  );
};

export default WhatsNewTabs;
